import { useTranslation } from "next-i18next";

import { MenuLinkStyled } from "./Menu.styled";

export const MenuLinks = () => {
  const { t } = useTranslation();

  return (
    <>
      <MenuLinkStyled href={"/projects"}>{t("projects")}</MenuLinkStyled>
      <MenuLinkStyled href={"/blog"}>{t("blog")}</MenuLinkStyled>
      <MenuLinkStyled href={"/about"}>{t("about us")}</MenuLinkStyled>
      <MenuLinkStyled href={"/contact"}>{t("contact")}</MenuLinkStyled>
    </>
  );
};
